import { render, staticRenderFns } from "./ValentinePage.vue?vue&type=template&id=2588592e"
import script from "./ValentinePage.vue?vue&type=script&lang=js"
export * from "./ValentinePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports